import type { ReactNode } from 'react';

/**
 * Whether a control's label is plain text short enough for the pixel display
 * face (design system 01 §3.3): Press Start 2P is very wide, so buttons take it
 * up to 12 characters and tags up to 8; anything longer — or anything that is
 * not plain text — stays in the reading face.
 */
export function isShortLabel(children: ReactNode, maxLength: number): boolean {
  if (typeof children === 'number') return String(children).length <= maxLength;
  if (typeof children !== 'string') return false;
  const length = [...children.trim()].length;
  return length > 0 && length <= maxLength;
}
